var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormHelperText } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React from 'react';
import { BootstrapInput } from 'react-components/BootstrapInput';
const useIconStyles = makeStyles((theme) => ({
    root: {
        marginTop: 2,
        marginRight: 5,
        color: theme.palette.primary.main
    }
}));
const iconComponent = (props) => {
    const classes = useIconStyles();
    return React.createElement(ExpandMore, Object.assign({}, Object.assign(Object.assign({}, props), { className: `${props.className} ${classes.root}` })));
};
export default React.forwardRef((props, ref) => {
    var _a, _b, _c;
    const { label, fullWidth, error, labelClassName, formControlProps } = props, selectProps = __rest(props, ["label", "fullWidth", "error", "labelClassName", "formControlProps"]);
    return (React.createElement(FormControl, Object.assign({ ref: ref, variant: (_a = props.variant) !== null && _a !== void 0 ? _a : 'filled', size: props.size, fullWidth: fullWidth, error: error, className: props.formControlClassName }, (formControlProps || {})),
        React.createElement(InputLabel, { variant: (_b = props.variant) !== null && _b !== void 0 ? _b : 'filled', className: labelClassName, shrink: !!props.value }, label),
        React.createElement(NativeSelect, Object.assign({ input: React.createElement(BootstrapInput, null), variant: (_c = props.variant) !== null && _c !== void 0 ? _c : 'filled' }, selectProps)),
        React.createElement(FormHelperText, { error: error, style: { display: error ? 'unset' : 'none' } }, props.errorText)));
});
